import { render, staticRenderFns } from "./VirtualServerLicenses.vue?vue&type=template&id=f131e0a2&"
import script from "./VirtualServerLicenses.vue?vue&type=script&lang=js&"
export * from "./VirtualServerLicenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports